import { getHelpCenterAri } from '@helpcenter/meta';
import { createResource, type RouterDataContext } from 'react-resource-router';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';

export interface MediaReadCredentialsResource {
    clientId: string;
    endpointUrl: string;
    tokenLifespanInSeconds: number;
    tokensWithFiles: {
        token: string;
        files: {
            attachmentId: number;
            attachmentMediaApiId: string;
            issueId: number;
        }[];
    }[];
}

export const mediaReadCredentialsResource = createResource<MediaReadCredentialsResource>({
    type: 'MEDIA_READ_CREDENTIALS_RESOURCE',
    getKey: () => `media-read-credentials`,
    getData: async ({ match }: RouterDataContext) => {
        const { helpCenterId } = HelpHelpCenterAri.parse(getHelpCenterAri());
        return fetchJson(
            `/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${
                match.params.requestKey || ''
            }/media/credentials/read`,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                },
            }
        );
    },
    maxAge: 0,
});
